import React from 'react'
import PropTypes from 'prop-types'
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap'
import generatePages from 'components/organisms/ListPagination/generate-pages'

const QueuePagination = ({ meta, loading, onChange }) => {
  const current = meta.current_page || 1, totalPages = Math.max(meta.total_pages || 1, 1)
  const count = meta.total_count || 0, size = meta.per_page || 15
  const pages = generatePages({ pagination: { current_page: current, total_pages: totalPages } })
  const item = (label, page, disabled, active = false, ariaLabel = label) => (
    <PaginationItem key={label} disabled={loading || disabled} active={active}>
      <PaginationLink tag='button' type='button' disabled={loading || disabled} aria-label={String(ariaLabel)}
        aria-current={active ? 'page' : undefined} onClick={() => onChange(page)}>{label}</PaginationLink>
    </PaginationItem>
  )
  return <div className='d-flex flex-wrap justify-content-between align-items-center mt-3'>
    <div className='mb-3 mr-3'><strong>{count ? (current - 1) * size + 1 : 0}–{Math.min(current * size, count)}</strong> dari {count} assignment
      <div className='text-muted small'>15 per halaman · Klik baris untuk melihat detail</div>
    </div>
    <Pagination aria-label='Navigasi Queue Semua SA' className='mb-3'>
      {item('«', 1, current <= 1, false, 'Halaman pertama')}
      {item('‹', current - 1, current <= 1, false, 'Halaman sebelumnya')}
      {pages.map((page) => item(page, page, false, current === page, `Halaman ${page}`))}
      {item('›', current + 1, current >= totalPages, false, 'Halaman berikutnya')}
      {item('»', totalPages, current >= totalPages, false, 'Halaman terakhir')}
    </Pagination>
  </div>
}
QueuePagination.propTypes = { meta: PropTypes.object.isRequired, loading: PropTypes.bool, onChange: PropTypes.func.isRequired }
export default QueuePagination
